export enum LogType {
    LOG = "LOG"
}
